export default "__VITE_ASSET__yBCzxZI1__"